exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./img/loading.gif"));

// Module
exports.push([module.id, "body{-webkit-tap-highlight-color:rgba(0,0,0,0);height:100%;margin:0}html{height:100%}.divAad{background-image:url(" + ___CSS_LOADER_URL___0___ + ");height:100%;background-position:center;background-repeat:no-repeat;background-size:cover}.spanMerging{display:flex;justify-content:center;align-items:center;height:200px;font-size:x-large}", ""]);

